export function encode(strings, ...keys) {
    const temp = [...strings];
    keys.forEach((key, i) => {
        temp[i] = temp[i] + encodeURIComponent(key);
    });
    return temp.join("");
}
